<template>
        <div class="text-center">
            <img :src="profileWidget.avatar" height="150" width="150" class="sau-avatar lg bdr-gray mx-auto mb-2">
            <h5 class="sau-para-m">{{profileWidget.firstname}} {{profileWidget.lastname}}</h5>
            <p class="sau-font xs">{{ label }} image by <a href="https://en.gravatar.com/" target="_blank">Gravatar</a> <span class="sau-help sm align-middle" v-b-tooltip :title="popup">?</span></p>
        </div>
</template>

<script>
export default {
    props:['mcc'],
    data(){
        return{
            //sauProfile:{}
        }
    },
    mounted(){
        //this.displayProfile();
    },
    methods:{
    },
    computed: {
        label() {
            return window.location.pathname.includes('contacts') ? 'Contacts' : 'Your';
        },
        popup() {
            return window.location.pathname.includes('contacts') ? 'We use your uploaded Gravatar image or a Gravatar unique image based on your email' : 'We use the contacts uploaded Gravatar image or a Gravatar unique image based on the contacts email'
        }
    }
}
</script>

<style>
</style>
